
import {
  Vue, Component, PropSync,
} from 'vue-property-decorator';

@Component
export default class AccountSpecification extends Vue {
  @PropSync('value', { default: false }) syncedValue!: boolean;
}
